
import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ModernHeroSection from "@/components/sections/ModernHeroSection";
import QuickOverviewSection from "@/components/sections/QuickOverviewSection";
import SectorNavigationSection from "@/components/sections/SectorNavigationSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import SocialProofSection from "@/components/sections/SocialProofSection";
import BottomCTASection from "@/components/sections/BottomCTASection";
import BackToTop from "@/components/ui/BackToTop";
import { useLocation } from "react-router-dom";
import { useGeolocation } from "@/components/pollster/hooks/useGeolocation";
import { useCountry } from "@/contexts/country";

const Index = () => {
  const location = useLocation();
  const { geoLocation } = useGeolocation();
  const { availableCountries } = useCountry();

  // Update page title and meta description
  useEffect(() => {
    document.title = "NationCard™ — Real-Time Public Sentiment & Verified Research Data";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Empower your organization with live citizen insights across 100+ countries. Verified voter panels, real-time sentiment tracking, and instant public concern alerts.');
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 w-full">
        <ModernHeroSection />
        <QuickOverviewSection />
        <SectorNavigationSection />
        <HowItWorksSection />
        <SocialProofSection />
        <BottomCTASection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Index;
